import React, { type ReactNode, type PointerEvent, useMemo } from 'react';
import Link from '@jira/platform__link-with-analytics/src/LinkWithAnalytics.tsx';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import type { UIAnalyticsEvent as AnalyticsEvent } from '@atlaskit/analytics-next';

type Props = {
	caption: ReactNode;
	href: string;
	onClick: (event: PointerEvent, analyticsEvent: AnalyticsEvent) => void;
};

export default function LinkCell({ caption, href, onClick }: Props): React.JSX.Element {
	const content = useMemo(() => {
		const innerContent = (
			<Box paddingInline="space.050">
				{href ? (
					<Link href={href} onClick={onClick}>
						{caption}
					</Link>
				) : (
					caption
				)}
			</Box>
		);

		return (
			<Box xcss={containerStyles}>
				<Box xcss={wrapperStyles}>
					<Tooltip
						content={caption}
						isScreenReaderAnnouncementDisabled
						delay={1000}
						position="bottom-start"
					>
						{innerContent}
					</Tooltip>
				</Box>
			</Box>
		);
	}, [caption, href, onClick]);

	return content;
}

const containerStyles = xcss({
	width: '100%',
	paddingBlock: 'space.100',
	flex: '1 1 auto',
	flexDirection: 'row',
	display: 'flex',
	height: '40px',
});

const wrapperStyles = xcss({
	paddingBlock: 'space.025',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});
